import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { ProductSchedulePeriodModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: "root",
})
export class ProductSchedulePeriodService extends ApiServiceBase {
    private readonly PATH = "/system/ProductSchedulePeriods";

    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getProductSchedulePeriods(): Observable<ProductSchedulePeriodModel[]> {
        return this.httpGet<ProductSchedulePeriodModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}